import { map, orderBy, filter } from 'lodash';
import countriesByAbbreviation from 'country-json/src/country-by-abbreviation.json';

export const entityFiltersFormatter = {
    formatAllEntityFilters
};

function formatAllEntityFilters(data, currentUser){
    const allCountries = countriesByAbbreviation.map(c=>({
        label: c.country,
        value: c.abbreviation
    }))
    
    let filters = orderBy(data, ['is_system', 'name'], ['desc', 'asc']);
    filters = map(filters, (filter)=>{
        filter.countries = filter.body.map(c=>({label: c.name, value: c.code}));
        filter.owner = filter.user_id == currentUser.id;
        return filter;
    });
    
    filters.unshift({
        name: 'Worldwide', 
        is_system: true,
        worldwide: true,
        countries: allCountries
    })

    
    filters.unshift({
        name: 'Overview', 
        is_system: true,
        overview: true,
        countries: []
    });
    
    return filters;
}
